// extracted by mini-css-extract-plugin
export default {"title":"c3a12ed49b","inner_title":"_1925dca1df","charge_btn":"ee1f142596"};